import {
  filtersToQueryObject,
  getStringQuery,
} from '@prisjakt/product-collection-urls';

import type { AggregationSection, ProductCollection } from 'src/types';

export const mergeIntoQueryArray = <T extends Record<string, unknown>>(
  arr: T[],
  obj: T,
  prop: keyof T
): T[] => {
  const currentObj = arr.find(item => item[prop] === obj[prop]);
  if (currentObj) {
    return arr.map(item =>
      item[prop] === obj[prop]
        ? {
            ...item,
            ...obj,
          }
        : item
    );
  }
  return arr.concat(obj);
};

// AGGREGATION_RECEIVE
export const aggregationReceive = (
  productCollection: ProductCollection,
  aggData: AggregationSection[]
) => {
  const slice = productCollection?.slices?.find(
    s => s?.__typename === 'FilterSlice'
  );

  if (!slice) {
    return productCollection;
  }

  if (slice.__typename === 'FilterSlice') {
    // There is a memo on the sections that we need to bail out from
    slice.sections = ([] as AggregationSection[]).concat(
      slice.sections.map(section => {
        const sectionUpdate = aggData.find(({ id }) => section.id === id);
        if (!sectionUpdate) {
          return section;
        }

        const result = {
          ...section,
          ...sectionUpdate,
        } as AggregationSection;

        return result;
      })
    );
  }

  return productCollection;
};

export const getProductCollectionPathKey = (state: any) => {
  const filters = (state?.filters || []).map((filter: any) =>
    filter.type === 'range'
      ? {
          // Don't update pathKey for different ranges
          ...filter,
          from: '',
          to: '',
        }
      : filter
  );
  return `${getStringQuery(filtersToQueryObject(filters))}:${
    state?.query?.offset || 0
  }`;
};
